import {
  GET_REVIEWS_SUCCESS,
  GET_REVIEWS_FAIL,
  GET_REVIEW_PROFILE_SUCCESS,
  GET_REVIEW_PROFILE_FAIL,
  ADD_REVIEW_SUCCESS,
  ADD_REVIEW_FAIL,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_FAIL,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAIL,
  DELETE_REVIEW,
  ADD_NEW_REVIEW,
  UPDATE_REVIEW
  
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  reviewProfile: {},
  error: {},
  loading:false
};

const reviews = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_REVIEWS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total_page: action.payload.total_page
      }

    case GET_REVIEWS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_REVIEW:
        return {
          ...state,
          loading:true
        }
    case ADD_REVIEW_SUCCESS:
      return {
        ...state,
        // reviews: [...state.reviews, action.payload],
        loading:false
      }

    case ADD_REVIEW_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_REVIEW:
        return {
          ...state,
          loading:true
        }
    case UPDATE_REVIEW_SUCCESS:
      return {
        ...state,
        data: state.data.map(review =>
          review.id.toString() === action.payload.id.toString()
            ? { ...review, ...action.payload }
            : review
        ),
        loading:false
      }

    case UPDATE_REVIEW_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_REVIEW:
      return {
        ...state,
        loading:true
      }
    case DELETE_REVIEW_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          review => review.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_REVIEW_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REVIEW_PROFILE_SUCCESS:
      return {
        ...state,
        reviewProfile: action.payload,
      }

    case GET_REVIEW_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default reviews;
